import { useMemo, useState } from 'react'
import '../../../style/Global.css'
import UserOrderList from '../../layout/Guest/UserOrderList';
import { useGetMyOrderByGuestIdQuery } from '../../../features/guest/guestApiSlice';
import { skipToken } from '@reduxjs/toolkit/query';
import { useSelector } from 'react-redux';
import { selectCurrentUserId } from '../../../features/auth/authSlice';
import { getRtkErrorMessage } from '../../../utils/getRtkErrorMessage';
import { STATUS_PRIORITY, TABS } from '../../../constant/constant';
import { useOrderSocket } from '../../../hooks/socket/useOrderSocket';
import { useStoreTimer } from '../../../utils/useStoreTimer';
import { useHandleResize } from '../../../hooks/useHandleResize';

export interface Order {
    id: string;
    customer: string;
    total: string;
    date: string;
    status: "pending" | "processing" | "cancelled" | "for pick-up";
}

export default function OrderModal() {

    const { storeOpen  } = useStoreTimer();
    const [windowHeight, setWindowHeight] = useState(window.innerHeight);
    const [activeTab, setActiveTab] = useState<string>("all");
    const [openOrder, setOpenOrder] = useState<number | null>(null);
    const guestId = useSelector(selectCurrentUserId)
    const { data: myOrders = [], isLoading, isError, refetch: refetchMyOrders, error } = useGetMyOrderByGuestIdQuery(guestId ?? skipToken);
    const errorMessage = getRtkErrorMessage(error);

    useOrderSocket()
    useHandleResize({setWindowHeight})

    const guestFilteredOrders = useMemo(() => {
        if (activeTab === 'all') {
            return [...myOrders].sort((a, b) => {
                const statusCompare =
                    STATUS_PRIORITY[a.status] - STATUS_PRIORITY[b.status];
                if (statusCompare !== 0) return statusCompare;
                return Number(b.orderID) - Number(a.orderID);
            });
        }

        return myOrders
            .filter((order) => order.status === activeTab)
            .sort((a, b) => Number(b.orderID) - Number(a.orderID));
    }, [myOrders, activeTab]);

    const handleToggle = (id: number) => {
        setOpenOrder((prev) => (prev === id ? null : id));
    };

    const isBusy = isLoading;

    return (
        <div 
            className="absolute top-full right-0 mt-[18px] w-[350px] min-[425px]:min-w-[395px] md:w-[450px] bg-white h-[650px] shadow-lg rounded-lg flex flex-col overflow-hidden p-2.5 space-y-1 "
            style={{ maxHeight: `${windowHeight - 100}px`, overflowY: "auto", zIndex: '20'}}
        >
            <div className="p-2 text-black flex justify-between items-center">
                <p className='text-sm font-semibold flex items-center justify-center'>My Order</p>
            </div>
            <hr className="h-px bg-gray-200 border-0" />
            <div className='flex justify-center items-center w-full'>
                <div className='flex w-full justify-center items-center'>
                    {TABS.map((tab, index) => (
                        <button 
                            key={index}
                            className={`max-[350px]:px-1 min-[351px]:px-2.5 py-1 text-[10px] md:text-[12px] capitalize transition-all duration-200
                                ${ activeTab === tab
                                    ? "border-b-2 border-orange-600 text-orange-600 font-medium"
                                    : "border-b-2 border-transparent text-black hover:border-gray-300"
                                }`}
                            onClick={() => {
                                setActiveTab(tab)
                                refetchMyOrders()
                            }}
                        >
                            {tab}
                        </button>
                    ))}
                </div>
            </div>
            
            <div className="overflow-hidden flex flex-colo rounded">
                <UserOrderList
                    storeOpen={storeOpen}
                    openOrder={openOrder}
                    handleToggle={handleToggle}
                    order={guestFilteredOrders ?? []}
                    isLoading={isBusy}
                    isError={isError}
                    errorMessage={errorMessage}
                />
            </div>
        </div>
    )
}
